// Userback snippet; https://app.userback.io/widget/
window.Userback = window.Userback || {};
window.Userback.access_token = '1112|1315|VXmT4k3wBAqG5f24XIqFf3gGdWxgI0lDYHx22AyDaYkfdmkb4L';

(function(id) {
    if (document.getElementById(id)) {return;}
    var s = document.createElement('script');
    s.id = id;
    s.src = 'https://static.userback.io/widget/v1.js';
    var parent_node = document.head || document.body;
    parent_node.appendChild(s);
})('userback-sdk');


// WEBPACK FOOTER //
// ./src/utils/feedback.js